export default "__VITE_ASSET__DRWcXn7$__"